var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section main-section download-app-container" },
    [
      _vm.loadingPromoCode || !_vm.accessToken
        ? _c("div", { staticClass: "section-content" }, [
            _c("div", { staticClass: "hourglass-outer" }, [_c("hourglass")], 1),
          ])
        : _vm.subscriptionActive
        ? _c("div", { staticClass: "section-content" }, [
            _c("div", { staticClass: "columns is-centered is-vcentered" }, [
              _c("div", { staticClass: "column" }, [_c("profile-active")], 1),
            ]),
          ])
        : _vm.subscriptionExpired
        ? _c(
            "div",
            { staticClass: "section-content" },
            [
              _c("title-comp", {
                staticClass: "margin-top-md",
                attrs: { name: _vm.$t("profile.expired_subscription") },
              }),
              _c("div", { staticClass: "columns is-centered is-vcentered" }, [
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("div", { staticClass: "split-container" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "subtitle has-text-centered no-line-break-mobile",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("profile.expired_promo_code_help1"))
                          ),
                        ]
                      ),
                    ]),
                    _c("profile-promo-code", {
                      on: {
                        onload: _vm.loadPromoCode,
                        onloaded: _vm.loadedPromoCode,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm.userState &&
          _vm.userState.voucher_active &&
          !_vm.userState.subscription_canceled
        ? _c("div", { staticClass: "section-content section-content-flex" }, [
            _c("div", { staticClass: "columns is-centered is-vcentered" }, [
              _c("div", { staticClass: "column" }, [
                _c(
                  "div",
                  {
                    staticClass: "split-container",
                    staticStyle: { "padding-top": "0" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-container",
                        staticStyle: {
                          width: "100%",
                          "padding-top": "0",
                          "padding-bottom": "0",
                        },
                      },
                      [
                        _vm.errorPage
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "columns is-centered is-vcentered is-multiline is-mobile",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "column is-narrow" },
                                    [
                                      _c("div", { staticClass: "field" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "control has-text-centered",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "button is-primary",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: _vm.loadUserState,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("button.refresh")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "article",
                                {
                                  staticClass: "message is-danger",
                                  attrs: { transition: "fade" },
                                },
                                [
                                  _c("div", { staticClass: "message-body" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("alert.generic_error"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          : [
                              _vm.subscriptionPayment &&
                              _vm.subscriptionPrice &&
                              (_vm.subscriptionPayment.has_trial ||
                                _vm.userState.has_trial)
                                ? _c(
                                    "div",
                                    { staticClass: "subscription-box" },
                                    [
                                      _c("p", { staticClass: "intro-slot" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("profile.subscription_promo")
                                          )
                                        ),
                                      ]),
                                      _vm.subscriptionPayment.special_trial
                                        ? _c(
                                            "p",
                                            { staticClass: "trial-slot" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.subscription_trial1",
                                                    {
                                                      date: _vm.getDate(
                                                        _vm.subscriptionPayment
                                                          .trial
                                                      ),
                                                    }
                                                  ) + " "
                                                )
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "profile.subscription_trial_free"
                                                    ) + " "
                                                  )
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.subscription_trial2",
                                                    {
                                                      date: _vm.getDate(
                                                        _vm.subscriptionPayment
                                                          .trial
                                                      ),
                                                    }
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            { staticClass: "trial-slot" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.subscription_trial1_month"
                                                  ) + " "
                                                )
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "profile.subscription_trial_free"
                                                    ) + " "
                                                  )
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.subscription_trial2_month"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                      _vm.subscriptionPayment.special_trial &&
                                      _vm.subscriptionPayment.discount
                                        ? _c(
                                            "div",
                                            { staticClass: "price-slot" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.subscription_after_trial",
                                                    {
                                                      new: _vm.subscriptionPrice,
                                                      amount:
                                                        _vm.formattedPrice,
                                                      perc: _vm.subscriptionDiscount,
                                                    }
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm.subscriptionPayment.discount
                                        ? _c(
                                            "div",
                                            { staticClass: "price-slot" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.subscription_after_trial_month",
                                                    {
                                                      new: _vm.subscriptionPrice,
                                                      amount:
                                                        _vm.formattedPrice,
                                                      perc: _vm.subscriptionDiscount,
                                                    }
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm.subscriptionPayment &&
                                  _vm.subscriptionPrice
                                ? _c(
                                    "div",
                                    { staticClass: "subscription-box" },
                                    [
                                      _c("p", { staticClass: "intro-slot" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("profile.subscription_promo")
                                          )
                                        ),
                                      ]),
                                      _c("p", { staticClass: "trial-slot" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "profile.subscription_notrial1",
                                              {
                                                date: _vm.getDate(
                                                  _vm.subscriptionPayment
                                                    .sub_end
                                                ),
                                              }
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm.subscriptionPayment.discount
                                        ? _c(
                                            "div",
                                            { staticClass: "price-slot" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.subscription_notrial2",
                                                    {
                                                      new: _vm.subscriptionPrice,
                                                      amount:
                                                        _vm.formattedPrice,
                                                      perc: _vm.subscriptionDiscount,
                                                    }
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "price-slot" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.subscription_notrial_nocoupon",
                                                    {
                                                      amount:
                                                        _vm.subscriptionPrice,
                                                    }
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "subscription-box" },
                                    [
                                      _c("p", { staticClass: "intro-slot" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("profile.subscription_promo")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                              _c("payment-help", {
                                attrs: {
                                  "subscription-payment":
                                    _vm.subscriptionPayment,
                                  "has-trial": _vm.userState.has_trial,
                                },
                              }),
                              _c("form", { attrs: { id: "payment-form" } }, [
                                _vm.subscriptionPayment
                                  ? _c("div", { staticClass: "field" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "label",
                                          attrs: { for: "fullname" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("placeholder.payment_name")
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("p", { staticClass: "control" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.fullname,
                                              expression: "fullname",
                                            },
                                          ],
                                          staticClass: "input",
                                          attrs: {
                                            id: "fullname",
                                            type: "text",
                                            name: "fullname",
                                            maxlength: "24",
                                          },
                                          domProps: { value: _vm.fullname },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.fullname = $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "field" }, [
                                  _vm.subscriptionPayment
                                    ? _c("label", { staticClass: "label" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("placeholder.payment_card")
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c("div", { attrs: { id: "card-element" } }),
                                  _vm._m(0),
                                  _vm.subscriptionPayment
                                    ? _c(
                                        "div",
                                        { staticClass: "margin-top-xs" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "90%",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("form.cvc_help"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm.subscriptionPayment
                                  ? _c(
                                      "div",
                                      { staticClass: "field margin-top-md" },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "checkbox" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.invoiceData,
                                                  expression: "invoiceData",
                                                },
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.invoiceData
                                                )
                                                  ? _vm._i(
                                                      _vm.invoiceData,
                                                      null
                                                    ) > -1
                                                  : _vm.invoiceData,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a = _vm.invoiceData,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.invoiceData =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.invoiceData = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.invoiceData = $$c
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "form.enter_invoice_data"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.invoiceData
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "field margin-top-xs",
                                          },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "label" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "placeholder.invoice_type"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "control" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "select",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.invoiceType,
                                                            expression:
                                                              "invoiceType",
                                                          },
                                                        ],
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.invoiceType =
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "company",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "placeholder.invoice_type_company"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "personal",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "placeholder.invoice_type_personal"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.invoiceType
                                          ? [
                                              _vm.invoiceType === "company"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field margin-top-xs",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "placeholder.company_name"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "control",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.companyName,
                                                                expression:
                                                                  "companyName",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "input",
                                                            attrs: {
                                                              type: "text",
                                                              maxlength: "40",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.companyName,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.companyName =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "columns is-centered is-vcentered is-multiline",
                                                  staticStyle: {
                                                    "padding-left": ".5rem",
                                                    "padding-right": ".5rem",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "column" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "placeholder.name"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "control",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.invoiceName,
                                                                expression:
                                                                  "invoiceName",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "input",
                                                            attrs: {
                                                              type: "text",
                                                              maxlength: "30",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.invoiceName,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.invoiceName =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "column" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "placeholder.surname"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "control",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.invoiceSurname,
                                                                expression:
                                                                  "invoiceSurname",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "input",
                                                            attrs: {
                                                              type: "text",
                                                              maxlength: "30",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.invoiceSurname,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.invoiceSurname =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm.invoiceType === "company"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "columns is-centered is-vcentered is-multiline",
                                                      staticStyle: {
                                                        "padding-left": ".5rem",
                                                        "padding-right":
                                                          ".5rem",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "column",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "placeholder.taxcode"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "control",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.invoiceTaxcode,
                                                                    expression:
                                                                      "invoiceTaxcode",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "input",
                                                                attrs: {
                                                                  type: "text",
                                                                  maxlength:
                                                                    "18",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.invoiceTaxcode,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.invoiceTaxcode =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "column",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "placeholder.vat"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "control",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.companyVat,
                                                                    expression:
                                                                      "companyVat",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "input",
                                                                attrs: {
                                                                  type: "text",
                                                                  maxlength:
                                                                    "13",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.companyVat,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.companyVat =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field margin-top-xs",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "placeholder.taxcode"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "control",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.invoiceTaxcode,
                                                                expression:
                                                                  "invoiceTaxcode",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "input",
                                                            attrs: {
                                                              type: "text",
                                                              maxlength: "18",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.invoiceTaxcode,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.invoiceTaxcode =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "columns is-centered is-vcentered is-multiline",
                                                  staticStyle: {
                                                    "padding-left": ".5rem",
                                                    "padding-right": ".5rem",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "column" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "placeholder.address"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "control",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.companyAddress,
                                                                expression:
                                                                  "companyAddress",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "input",
                                                            attrs: {
                                                              type: "text",
                                                              maxlength: "48",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.companyAddress,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.companyAddress =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "column is-narrow",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "placeholder.postalCode"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "control",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.companyPostalCode,
                                                                expression:
                                                                  "companyPostalCode",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "input",
                                                            attrs: {
                                                              type: "text",
                                                              maxlength: "6",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.companyPostalCode,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.companyPostalCode =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "columns is-centered is-vcentered is-multiline",
                                                  staticStyle: {
                                                    "padding-left": ".5rem",
                                                    "padding-right": ".5rem",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "column" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "placeholder.city"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "control",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.companyCity,
                                                                expression:
                                                                  "companyCity",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "input",
                                                            attrs: {
                                                              type: "text",
                                                              maxlength: "48",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.companyCity,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.companyCity =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "column" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "placeholder.province"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "control",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.companyProvince,
                                                                expression:
                                                                  "companyProvince",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "input",
                                                            attrs: {
                                                              type: "text",
                                                              maxlength: "48",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.companyProvince,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.companyProvince =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm.invoiceType === "company"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "columns is-centered is-vcentered is-multiline",
                                                      staticStyle: {
                                                        "padding-left": ".5rem",
                                                        "padding-right":
                                                          ".5rem",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "column",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "placeholder.pec"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "control",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.companyPec,
                                                                    expression:
                                                                      "companyPec",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "input",
                                                                attrs: {
                                                                  type: "text",
                                                                  maxlength:
                                                                    "48",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.companyPec,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.companyPec =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "column",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "placeholder.destinationCode"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "control",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.companyDestCode,
                                                                    expression:
                                                                      "companyDestCode",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "input",
                                                                attrs: {
                                                                  type: "text",
                                                                  maxlength:
                                                                    "48",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.companyDestCode,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.companyDestCode =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm.subscriptionPayment
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "has-text-centered margin-top-md",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "button is-primary",
                                            staticStyle: {
                                              "min-width": "150px",
                                            },
                                            attrs: { type: "button" },
                                            on: { click: _vm.submitPayment },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.subscriptionPayment
                                                  .has_trial ||
                                                  _vm.userState.has_trial
                                                  ? _vm.$t(
                                                      "button.submit_trial"
                                                    )
                                                  : _vm.$t("button.submit_pay")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.subscriptionPayment
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "has-text-centered margin-top-sm",
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: { "max-width": "320px" },
                                          attrs: {
                                            src: "/img/stripe_secure_payments.png",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.loadingPayment
                                  ? _c(
                                      "div",
                                      { staticClass: "loading-payment" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "hourglass-outer" },
                                          [_c("hourglass")],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        : _c(
            "div",
            { staticClass: "section-content section-content-flex" },
            [
              _c("title-comp", {
                staticClass: "margin-top-md",
                attrs: { name: _vm.$t("title.download_app") },
              }),
              _c("div", { staticClass: "columns is-centered is-vcentered" }, [
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("div", { staticClass: "split-container" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "subtitle has-text-centered no-line-break-mobile",
                        },
                        [_vm._v(_vm._s(_vm.$t("profile.promo_code_help1")))]
                      ),
                    ]),
                    _c("profile-promo-code", {
                      on: {
                        onload: _vm.loadPromoCode,
                        onloaded: _vm.loadedPromoCode,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "margin-top-xs" }, [
      _c("div", { attrs: { id: "card-element-errors", role: "alert" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }